import React from 'react'
import { Box, Flex } from '@creditas-ui/react'
import { PULSING_VARIANTS } from 'domain/enums'
import { PulsingCircle } from 'shared/ui'
import { DOCUMENTS_NEEDED_HEADERS } from 'document/domain/constants'
import {
  DocumentTitle,
  DocumentSubtitle,
} from './DocumentsRequiredDetails.styles'
import { DocumentsRequiredSkeleton } from './DocumentsRequiredSkeleton'

export const DocumentsRequiredDetails = ({ documentsRequired }) => {
  const { items, loading } = documentsRequired
  return loading ? (
    <DocumentsRequiredSkeleton />
  ) : (
    <Box>
      {items?.map(documentRequired => (
        <Box
          marginBottom="16px"
          key={documentRequired}
          data-testid="document-required-description"
        >
          <Flex>
            <PulsingCircle variant={PULSING_VARIANTS.PENDING} size={4} />
            <DocumentTitle>
              {DOCUMENTS_NEEDED_HEADERS[documentRequired].title}
            </DocumentTitle>
          </Flex>
          <DocumentSubtitle>
            {DOCUMENTS_NEEDED_HEADERS[documentRequired].subtitle}
          </DocumentSubtitle>
        </Box>
      ))}
    </Box>
  )
}
